import React, { Component } from "react";
import PropTypes from "prop-types";
import RelatedLinkItem from "./RelatedLinkItem";

class RelatedLinks extends Component {
  render() {
    const { items, title } = this.props;
    return (
      <div className="product-options__section d-flex flex-wrap px-2 py-4 align-items-center related-links">
        <div className="related-links__title py-5">{title}</div>
        <ul className="d-flex flex-wrap">
          {items.map(({ title, link }) => (
            <RelatedLinkItem title={title} link={link} />
          ))}
        </ul>
      </div>
    );
  }
}

RelatedLinks.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default RelatedLinks;
